import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg xmlns="http://www.w3.org/2000/svg" width="87" height="79" viewBox="0 0 87 79" {...this.props}><path fill="none" stroke="#0070BA" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18.438 30.958l-.206 38.865h49.515V30.958H81.64L43.274 1 1.546 30.958h54.61m-4.757 38.865V30.958M1 77.381h85m-50.945-7.558V30.958" /></svg>;
  }

}